export default [
  {
    path: '/finance/:pageType/:folder*',
    name: 'trust-finance-invoice',
    component: () => import('@/views/creative-upload/Index.vue')
  },
]
